import { render, staticRenderFns } from "./integral.vue?vue&type=template&id=831e1aca&scoped=true&"
import script from "./integral.vue?vue&type=script&lang=js&"
export * from "./integral.vue?vue&type=script&lang=js&"
import style0 from "./integral.vue?vue&type=style&index=0&id=831e1aca&prod&lang=scss&"
import style1 from "./integral.vue?vue&type=style&index=1&id=831e1aca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831e1aca",
  null
  
)

export default component.exports